import React, { FC, useCallback } from "react";
import { useTranslation } from "react-i18next";
import { Icon, useDialogShadow } from "@evergis/ui";

import { DialogActions } from "../../DialogComponents/DialogActions";
import { DialogTitle } from "../../DialogComponents/DialogTitle";
import { FullScreenDialog } from "../../DialogComponents/FullScreenDialog";
import { ImportWizard } from "./ImportWizard";
import { SpatialReferenceBlock } from "./SpatialReferenceBlock";
import { useImportContext } from "../importContext";
import { useContext } from "../hooks/useContext";
import { InfoMessage, MessageContent, SpatialContentContainer } from "../styled";

export const ImportSpatialReference: FC = () => {
  const { t } = useTranslation("common");
  const context = useContext();
  const { shadows, setScrollContainer } = useDialogShadow();
  const {
    prevStep,
    nextStep,
    srFields,
    attributes,
    setAttributes: setContextAttributes,
    updateSrField,
    lonLatInOneField,
    setLonLatInOneField,
    geometrySpecified,
  } = useImportContext();

  const onApply = useCallback(() => {
    setContextAttributes(attributes);
    nextStep();
  }, [attributes, nextStep, setContextAttributes]);

  return (
    <FullScreenDialog dialogContext={context}>
      <DialogTitle displayShadow={shadows.upper} extra={<ImportWizard />} />
      <SpatialContentContainer ref={setScrollContainer}>
        <SpatialReferenceBlock
          srFields={srFields}
          attributes={attributes}
          updateSrField={updateSrField}
          lonLatInOneField={lonLatInOneField}
          setLonLatInOneField={setLonLatInOneField}
          geometrySpecified={geometrySpecified}
        />
      </SpatialContentContainer>
      <DialogActions
        displayShadow={shadows.bottom}
        applyText={t("actions.next")}
        backButtonText={t("import.back", { ns: "dialogs" })}
        onBackButton={prevStep}
        onApply={onApply}
      >
        {!geometrySpecified && (
          <InfoMessage success>
            <Icon kind="info" />
            <MessageContent>
              <span>{t("import.importNoGeometryInfo", { ns: "dialogs" })}</span>
            </MessageContent>
          </InfoMessage>
        )}
      </DialogActions>
    </FullScreenDialog>
  );
};
